<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <span>技術與產品</span>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 设计中心 -->
      <section id="sjzx">
        <div class="container gradient-background">
          <div class="row">
            <div class="col-lg-12 rzTop">
              <h1><span>華胤集團工程設計</span></h1>
              <p>
                華胤集團依據現代設計理念和國家相應標準進行工程設計。華胤擁有自己的設計中心，並且擁有鋼結構設計甲級證書，擁有強大的專業設計隊伍，分別位於江蘇海安和崑山。
                採用國際先進的MBS,X-STEEL，PKPM、 3D3S
                、STAADPRO、MBS、MTS、CFS、XSTEEL等設計軟體，能完成結構設計到制造詳圖的全部設計工作。設計經驗超過四千件，涉及不同的領域。
                提供完整的鋼結構制作及安裝圖紙，使制作及施工能準確且有效率的進行。
              </p>
              <div class="container-fluid">
                <div
                  class="col-lg-6 col-xs-6"
                  v-for="(item, index) in sjzxList"
                  :key="index"
                >
                  <div class="sjzxImg">
                    <img :src="item.image" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 系统产品 -->
          <section id="xtcp">
            <div class="row">
              <div class="col-lg-12 xtTop">
                <h1><span>華胤集團系統產品</span></h1>
              </div>
            </div>

            <div class="container-fluid">
              <div
                class="col-lg-6 col-xs-6"
                v-for="(item, index) in xtList"
                :key="index"
                @click="openModal(index)"
              >
                <div class="xtImg">
                  <img :src="item.image" alt="" />
                  <p class="xtp">{{ item.text }}</p>
                </div>
              </div>
            </div>
            <div v-if="isModalOpen" class="modal">
              <div class="modal-content">
                <span class="xmodaltop">華胤集團系統產品</span>
                <!-- 关闭按钮 -->
                <span class="xclose" @click="closeModal">&times;</span>
                <!-- 详细内容 -->
                <div class="xxd">
                  <el-carousel
                    :autoplay="false"
                    trigger="click"
                    indicator-position="outside"
                    :initial-index="this.selectedIndex"
                  >
                    <el-carousel-item
                      v-for="(item, index) in xtxqList"
                      :key="index"
                    >
                      <div class="col-lg-12 xxnrbor">
                        <div class="content">
                          <div class="img-container visible-lg">
                            <img :src="item.image" alt="Lazy-loaded Image" />
                          </div>
                          <div class="text-container col-xs-12">
                            <h3>{{ item.htext }}</h3>
                            <img
                              :src="item.image"
                              alt="Lazy-loaded Image"
                              class="hidden-lg"
                            />
                            <p style="white-space: pre-line">
                              {{ item.ptext }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </section>

          <!-- 华胤专利 -->
          <section id="hyzl">
            <div class="row">
              <div class="col-lg-12 rzTop">
                <h1><span>華胤集團專利</span></h1>
                <p>
                  華胤注重研發廠房建築技術,榮獲12項鋼結構專利,例如新型系桿,屋面透氣裝置及屋面鋼板抗風滑動固定座等,有助於降低工廠耗能及提高耐用性。
                </p>
              </div>
            </div>
            <div>
              <h2>
                <span class="hspan"
                  ><span style="color: red">///////// </span>專利證書</span
                >
              </h2>
            </div>
            <div class="container-fluid">
              <div
                class="col-lg-1-5 col-xs-4"
                v-for="(item, index) in jtzlList"
                :key="index"
              >
                <div class="portfolio-item">
                  <div class="thumb">
                    <div class="image">
                      <div class="demo-image__preview jtzlImg">
                        <el-image
                          style="height: 100%"
                          :src="item.image[0]"
                          :preview-src-list="item.image"
                        >
                        </el-image>
                      </div>
                    </div>
                    <div class="hover-effect">
                      <div
                        class="hover-content jtzlHeight"
                        style="white-space: pre-line"
                      >
                        <h1>{{ item.text }}</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- 安裝服務 -->
          <section id="azfw">
            <div class="row">
              <div class="col-lg-12 rzTop">
                <h1><span>安裝服務</span></h1>
                <p>
                  華胤已成功完成4000多個工程項目，累積了豐富的專案管理經驗。採用專案經理管理體系，有效率地進行工程管理及現場服務。專案經理與業主、設計院、監理、政府相關部門和其他承建商保持密切的工作關系，使得專案執行順利進行。具體有效的措施，確保現場工地對安全的要求。完善的售後服務，保證客戶無後顧之憂。
                </p>
              </div>
              <div class="col-lg-12 azTop">
                <img
                  src="@/components/img/cpyfw/azfw.jpg"
                  alt=""
                  style="width: 85vw"
                />
              </div>
            </div>
          </section>

          <!-- 新能源 -->
          <section id="gsxny">
            <div class="row">
              <div class="col-lg-12 nyTop">
                <h1><span>國盛新能源</span></h1>
                <p>
                  華胤集團除鋼結構工程外，亦積極拓展再生能源事業。
                  透過自有工廠屋頂建置太陽能發電系統，提供從開發、設計、施工到營運（EPC＋O&M）的一體化服務，實現穩定且可持續的電力供應。
                  所產生之電力除供應自有工廠使用外，亦併入電網，支援產業用電及公共電力需求。
                  結合鋼結構工程技術優勢，華胤提供屋頂型、工廠型及工業型太陽能發電解決方案，協助客戶降低能源成本並減少碳排放，實現永續發展。
                </p>
              </div>
              <div class="col-lg-12">
                <div class="xnyNum">
                  <div class="xnytitle">
                    NO.1 國盛太陽能發電項目<br />（自有電廠）
                  </div>
                  <div>
                    <carousel-3d
                      :controlsVisible="true"
                      :width="cWidth"
                      :height="cHeight"
                      :display="5"
                      :space="280"
                    >
                      <slide :index="0">
                        <img
                          v-lazy="hyxny1"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="1">
                        <img
                          v-lazy="hyxny2"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="2">
                        <img
                          v-lazy="hyxny3"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="3">
                        <img
                          v-lazy="hyxny4"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="4">
                        <img
                          v-lazy="hyxny5"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                    </carousel-3d>
                  </div>
                  <div class="xnyContent">
                    <p>
                      國盛電站為華胤集團推動的工廠屋頂太陽能發電項目，採用高效率的分布式太陽能系統（亦稱光伏發電系統），專為工業用場景打造。<br />
                      系統設置於廠房屋頂，實現「就近發電、就近使用」，有效降低電力傳輸損耗，提升能源使用效率。<br />
                      透過高效太陽能模組，將太陽能直接轉換為電能，支援企業日常用電需求，同時實現「自發自用、餘電上網」的運行模式，在降低用電成本的同時創造額外收益。
                    </p>
                  </div>
                </div>
                <div class="xnyNum">
                  <div class="xnytitle">NO.2 森鋼電廠太陽能發電項目</div>
                  <div>
                    <carousel-3d
                      :controlsVisible="true"
                      :width="cWidth"
                      :height="cHeight"
                      :display="5"
                      :space="280"
                    >
                      <slide :index="0">
                        <img
                          v-lazy="hyxny6"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="1">
                        <img
                          v-lazy="hyxny7"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="2">
                        <img
                          v-lazy="hyxny8"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="3">
                        <img
                          v-lazy="hyxny9"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                      <slide :index="4">
                        <img
                          v-lazy="hyxny10"
                          style="width: 100%; height: 100%"
                          alt=""
                        />
                      </slide>
                    </carousel-3d>
                  </div>
                  <div class="xnyContent">
                    <p>
                      森鋼電站為華胤集團參與建置之大型工廠屋頂太陽能發電項目，總裝置容量達
                      2MW（2000kW），屬於高效率的分布式太陽能發電系統（Distributed
                      Solar System），廣泛應用於工業製造廠房。<br />
                      本案設置於安徽森鋼裝配製造有限公司廠房屋頂，採用彩鋼瓦屋面結構，配置
                      575Wp高效單晶太陽能模組共3,478片，實現高密度發電配置，最大化屋頂空間利用效率。<br />
                      系統採用「自發自用、餘電上網」模式運行，並以
                      380V低壓並網系統接入廠區電力系統，有效降低企業用電成本，同時提升能源自主性。<br />
                      在電力轉換方面，本項目配置
                      16台組串式逆變器（575kW級），並新增多組並網櫃，將太陽能所產生之直流電轉換為交流電後，透過既有電力系統輸送至用電端，確保系統穩定與高效率運行。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
      <!-- 邮箱 -->
      <div class="mailbg">
        <to-mail button-text="聯絡我們"></to-mail>
      </div>
      <!-- 小滾輪 -->
      <div id="ss_menu">
        <div>
          <i
            ><a @click="forId('sjzx')">工程<br />設計</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('xtcp')">系統<br />產品</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('hyzl')">華胤<br />专利</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('azfw')">安装<br />服务</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('gsxny')">国盛<br />新能源</a></i
          >
        </div>
        <div class="menu">
          <div class="share" id="ss_toggle" data-rot="180">
            <div class="circle"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isModalOpen: false, // 控制模态框的显示状态
      selectedIndex: 0,
      sjzxList: [
        {
          image: require('@/components/img/cpyfw/sjzx1.png'),
        },
        {
          image: require('@/components/img/cpyfw/sjzx2.png'),
        },
        {
          image: require('@/components/img/cpyfw/sjzx3.png'),
        },
        {
          image: require('@/components/img/cpyfw/sjzx4.png'),
        },
      ],
      xtList: [
        {
          image: require('@/components/img/cpyfw/xtcp1.jpg'),
          text: '通風系統',
        },
        {
          image: require('@/components/img/cpyfw/xtcp2.jpg'),
          text: '屋面系統',
        },
        {
          image: require('@/components/img/cpyfw/xtcp3.jpg'),
          text: '採光系統',
        },
        {
          image: require('@/components/img/cpyfw/xtcp4.jpg'),
          text: '檁條圍樑',
        },
        {
          image: require('@/components/img/cpyfw/xtcp5.jpg'),
          text: '樓層系統',
        },
        {
          image: require('@/components/img/cpyfw/xtcp6.jpg'),
          text: '主鋼系統',
        },
        {
          image: require('@/components/img/cpyfw/xtcp7.jpg'),
          text: '牆面系統',
        },
        {
          image: require('@/components/img/cpyfw/xtcp8.jpg'),
          text: '預制結構',
        },
      ],
      xtxqList: [
        {
          image: require('@/components/img/cpyfw/cpjs1.jpg'),
          htext: '華胤通風系統',
          ptext:
            '利用室內溫差產生熱動力，以及室內外自然風形成的風動力，從建築物的低層牆壁上的空氣入口吸入新鮮空氣，並將內部熱氣廢氣，及有毒氣體由通風器出口排出，從而達到排氣效果。\n與機械通風系統比較有以下列優勢：經濟成本低,自動調節換氣量,寧靜無震動,專業設計，安裝快捷方便',
        },
        {
          image: require('@/components/img/cpyfw/cpjs2.jpg'),
          htext: '華胤屋面系統',
          ptext:
            'SD屋面系統\n使用特配的封閉式滑動固定座與360°雙層卷邊鎖縫氣密連接，抗颱風能力強，保溫效果佳，防漏性能優。\nLD屋面系統\nLD屋面板由兩個特配的固定座以互扣及三明治方式連接固定,具有完美的防漏抗風雪能力和超強承載力\nKD屋面系統\n使用特配的隱藏式固定座與鋼板互扣合連接的屋面系統,抗風能力強，防漏性能好,熱脹冷縮時鋼板可移動，避免鋼板損壞\nCD 雙層屋面系統\n螺絲直接穿透鋼板固定系統,普遍經濟型的屋面系統，特殊的連接方式，有效地防風及防漏\nVD高波屋面系統：\n具有獨特的V型波峯結構，波峯高度176mm，具備高排水深度。最大檁條間距可達3米，同時採用360°鎖縫和滑動固定座技術，適用於大跨度、大檁距的建築屋面。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs3.jpg'),
          htext: '華胤採光系統',
          ptext:
            '採光板是一種用於建築物的材料，可以提供高效且無害的自然照明。它的設計和結構使得室內可以獲得充足的自然光線，從而減少對人工照明的依賴。與傳統的照明設備相比，採光板無需使用電力，因此可以降低能源消耗和電費支出。\n此外，採光板的表面覆膜具有一定的功能性。它可以隔絕99.9%的紫外線，從而有效地保護室內的人員和物品免受紫外線的傷害。同時，表面覆膜還具有防老化和防變色的特性，可以保持板材的外觀和性能長時間穩定，延長其使用壽命。\n透光率：透明色(70%)；乳白色(58%)。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs4.jpg'),
          htext: '次結構系統',
          ptext:
            '次結構系統是建築物屋面板和牆面板的連接支撐，通常安裝在屋樑和柱子上。在這個系統中，檁條是一種重要的組成部分，它是連接屋面板和牆面板的橫向支撐結構。\n檁條的材質通常是高強度連續熱浸鍍鋅或鍍鋁鋅鋼板，這種材質具有很好的耐腐蝕性能，可以保證檁條在惡劣環境下也能長期使用。此外，檁條的表面光潔、美觀，可以爲屋面和牆面提供更好的外觀效果。\n檁條的類型主要有“C”型和“Z”型兩種。其中，“C”型檁條的截面形狀類似於字母“C”，它通常用於支撐屋面板。而“Z”型檁條的截面形狀類似於字母“Z”，它通常用於支撐牆面板。這兩種檁條的類型可以根據建築物的具體需求進行選擇和安裝。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs5.jpg'),
          htext: '多層系統',
          ptext:
            '具備與低層預製鋼結構系統相同特點，相對於傳統的鋼筋混凝土結構，多層鋼結構系統更有效縮短工期，控制施工品質。\n樓層厚度與柱的尺寸可減少到最低程度，從而減少建築高度，提供更多使用空間，減少了建築空間，節約了不必要的熱能和空調供應。\n輕巧的結構減輕了對地基的荷載，從而節省了地基成本。\n地板可由華胤組合樓層板在現場與混凝土澆築而成。在任何氣候條件下都能快速施工的樓承板系統，以其質輕，及強度和重量對比性能高，耐用美觀等特點，長期以來一直爲設計師們所肯定。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs6.jpg'),
          htext: '主結構系統',
          ptext:
            '主結構是支撐整個鋼結構建築的鋼樑與鋼柱，由H型鋼焊接而成。 材料按工程設計，採用國家標準的Q235B或Q345B鋼材。 根據每項工程的特殊情況設計，提供多種框架形式供選擇。\n先進的自動焊接設備，確保焊縫品質及構件質量達到國家標準。 採用進口多方向噴珠除鏽設備，確保鏽漬徹底清除。 表面噴塗防鏽底漆，確保鋼構得到最佳防鏽功能。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs7.jpg'),
          htext: '華胤牆面系統',
          ptext:
            'CDII牆面系統\n螺絲外露，普遍經濟型，安裝便捷，適用於各類建築\nRD牆面系統\n獨特的波峯，螺絲半隱藏在波槽內，整面牆外觀清晰大方，普遍經濟型，安裝便捷，適用於各類建築\nPD牆面系統\nPD牆板使用互扣隱藏連接方式，表面無螺絲暴露， 牆身40毫米厚的空間，允許夾入較厚的保溫材料提高保溫效能\nPU50/MW60三明治系統\n板面由兩層彩色鋼板作面板，提供PU50聚氨酯和MW60岩棉兩種材質的莢芯板，提供平滑的特殊低凹槽和鋸齒條紋。\nCP雙層牆面板系統\n由華胤任一種屋面板與LND內層板組成，內夾玻璃棉保溫層，內層板能爲屋面內層提供光潔之表面，同時保護屋面保溫層。',
        },
        {
          image: require('@/components/img/cpyfw/cpjs8.jpg'),
          htext: '低層預製鋼結構系統',
          ptext:
            '低層預製鋼結構系統是一種現代化建築系統，所有材料以鋼爲主，通過先進的設計軟件優化設計，在工廠經過高精密加工而成，現場類似於搭積木般通過連接件拼裝而成，無需任何現場焊接、加工。\n特點：工期短，質量易控制，維修低，實用面積大，柱距可按生產工藝佈置，外觀具現代化美感，易擴建。 適用於各行業的廠房、物流倉庫及飛機庫、造船廠等大面積的、大跨度建築。',
        },
      ],
      jtzlList: [
        {
          image: [require('@/components/img/cpyfw/zlzs1.jpg')],
          text: '新型v型拉桿',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs2.jpg')],
          text: '新型抗風扣合板',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs3.jpg')],
          text: '屋面透氣裝置',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs4.jpg')],
          text: '屋面金屬板\n安裝裝置',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs5.jpg')],
          text: '屋面鋼板抗風\n結構固定座',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs6.jpg')],
          text: '手動開門機',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs7.jpg')],
          text: '凹凸型壓花\n鋼承樓板',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs8.jpg')],
          text: '對稱雙加勁條\n鋼承樓板',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs9.jpg')],
          text: '捲簾門抗風裝置',
        },
        {
          image: [require('@/components/img/cpyfw/zlzs10.jpg')],
          text: '鋼板夾合式屋面',
        },
      ],
      hyxny1: require('@/components/img/cpyfw/xny1.png'),
      hyxny2: require('@/components/img/cpyfw/xny2.png'),
      hyxny3: require('@/components/img/cpyfw/xny3.png'),
      hyxny4: require('@/components/img/cpyfw/xny4.png'),
      hyxny5: require('@/components/img/cpyfw/xny5.png'),
      hyxny6: require('@/components/img/cpyfw/xny6.png'),
      hyxny7: require('@/components/img/cpyfw/xny7.png'),
      hyxny8: require('@/components/img/cpyfw/xny8.png'),
      hyxny9: require('@/components/img/cpyfw/xny9.png'),
      hyxny10: require('@/components/img/cpyfw/xny10.png'),
    }
  },
  methods: {
    // 調用全局方法，滾動指定id
    forId(tId) {
      console.log(tId)
      this.$store.dispatch('toID', tId)
    },

    // 打开模态框
    openModal(index) {
      console.log(index)

      this.selectedIndex = index
      this.isModalOpen = true
      console.log(this.selectedIndex)
    },
    // 关闭模态框
    closeModal() {
      this.isModalOpen = false
    },
    //改变高度
    changeHeight() {
      if (document.body.clientWidth >= 2000) {
        this.cWidth = 1300
        this.cHeight = 700
      } else if (document.body.clientWidth >= 768) {
        this.cWidth = 900
        this.cHeight = 400
      } else if (document.body.clientWidth < 768) {
        this.cWidth = 1000
        this.cHeight = 400
      }
    },
  },
  mounted() {
    // 獲取高度
    window.onresize = () => {
      this.changeHeight()
    }
  },
  created() {
    this.changeHeight()
  },
  updated() {
    if (this.scrollToElement) {
      this.scrollToElement()
      this.scrollToElement = null
    }
  },
}
</script>

<style scoped>
/* 榮譽圖片註釋設置 */
#xtcp .row,
#hyzl .row,
#azfw .row,
#gsxny .row {
  border-top: 1px solid #000;
}
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/cpyfw/1.jpg) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  position: relative;
  width: 100%;
  background-size: 100% 100%;
}

/*-- banner-info --*/
.banner-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.banner-info span {
  font-size: 50px;
  color: #fff;
  padding: 0 10px;
  margin: 0 auto;
  line-height: normal;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
/***** Lexi *****/
/* 小滾輪 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px !important;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #415160;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 13px;
  text-align: center;
  background: #415160;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #2a2f34;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -180px;
}

#ss_menu div:nth-child(2) {
  top: -70px;
  left: -160px;
}

#ss_menu div:nth-child(3) {
  top: -130px;
  left: -130px;
}

#ss_menu div:nth-child(4) {
  top: -160px;
  left: -70px;
}

#ss_menu div:nth-child(5) {
  top: -180px;
  left: 0px;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.hspan,
.hspan2 {
  display: inline-block;
  position: relative;
  padding: 10px 20px;
  font-size: 30px;
  font-weight: 600;
}

.sjzxImg {
  position: relative; /* 父容器设为相对定位 */
  width: 100%;
  height: 28vw; /* 按需设置高度 */
  overflow: hidden; /* 防止图片溢出 */
  margin: 15px 0;
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

.xtImg {
  position: relative; /* 父容器设为相对定位 */
  width: 100%;
  height: 10vw; /* 按需设置高度 */
  overflow: hidden; /* 防止图片溢出 */
  margin: 15px 0;
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

.xtImg img,
.sjzxImg img {
  width: 100%;
  height: 100%;
}

.xtp {
  position: absolute;
  top: 50%; /* 父容器高度的50% */
  left: 50%; /* 父容器宽度的50% */
  transform: translate(-50%, -50%); /* 修正自身宽高偏移 */
  background: rgba(128, 128, 128, 0.7); /* 灰色半透明背景 */
  color: white;
  padding: 10px 80px; /* 文字内边距 */
  border-radius: 4px; /* 可选：圆角 */
  text-align: center;
  font-size: 30px;
  width: 40vw;
}

.container-fluid {
  margin: 60px auto;
}

.rzTop {
  margin: 60px 0;
  text-align: center;
}
.azTop {
  margin-bottom: 100px;
  text-align: center;
}
.rzTop h1 {
  margin: 50px 0;
}
.rzTop h1 span {
  padding-bottom: 0px;
  font-size: 37px;
  font-weight: 800;
}
.rzTop p,
.nyTop p {
  margin: 0 auto;
  width: 85vw;
  text-align: left;
  font-size: 26px;
  line-height: 40px;
}

.nyTop {
  margin: 60px 0;
  text-align: center;
}
.nyTop h1 {
  margin: 50px 0;
}
.nyTop h1 span {
  padding-bottom: 0px;
  font-size: 37px;
  font-weight: 800;
}

.zzzsHeight {
  height: 70px;
}
.sjzxHeight {
  height: 70px;
}
.jtzlHeight {
  height: 70px;
}
.hover-content h1 {
  font-size: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.gradient-background {
  padding: 0 85px 100px;
  border-top: 1px solid #000;
  width: 100%;
  height: 100%; /* 設置高度為視口高度 */
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.mailbg {
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.xtTop {
  margin-top: 60px;
  text-align: center;
}
.xtTop h1 {
  margin-top: 50px;
}
.xtTop h1 span {
  padding-bottom: 0px;
  font-size: 37px;
  font-weight: 800;
}

/* 模态框样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  position: relative;
  background-color: #58585a;
  padding: 70px 0;
  border-radius: 8px;
  max-width: 100vw;
  height: 100vh;
  text-align: center;
}

.xmodaltop {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 40px;
  color: #fff;
  text-align: center;
  width: 90vw;
}

/* 关闭按钮 */
.xclose {
  position: absolute;
  top: 10px;
  right: 25px;
  font-size: 26px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 50%;
  opacity: 1;
}

.xxd {
  width: 100vw;
  height: auto;
  max-height: 90%;
}

.xxImg {
  max-width: 100%;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.xxp {
  padding: 5px;
}

.jtzlImg {
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

div /deep/ .jtzlImg img {
  padding: 5px;
  width: 100%;
  overflow: hidden;
  height: 10vw;
  border: 0;
}

/* 新能源 */
.xnytitle {
  font-size: 60px; /*設置文字大小*/
  color: #000; /*設置文字顔色*/
  font-weight: bolder; /*設置文字寬度*/
  text-align: center; /*設置文字居中*/
}
.xnyNum {
  margin: 20px;
  padding: 20px;
  border: 1px solid black;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.xnyContent {
  margin: 10px;
  font-size: 24px;
  max-width: 100%;
}

.xxnrbor {
  padding: 0 100px;
  height: 80vh;
}

div /deep/ .el-carousel__container {
  height: 90vh;
}

div /deep/ .el-carousel__arrow {
  height: 50px;
  width: 50px;
  font-size: 33px;
}

div /deep/ .el-carousel__arrow--right {
  right: 34px;
}

/* 系统 */
.content {
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
  width: 90vw;
  display: flex;
}

.content .img-container {
  float: left;
  margin-right: 20px;
}

.content .img-container img {
  width: 40vw;
  height: 70vh;
}

.content .text-container {
  border: 1px solid #000;
  border-radius: 10px;
  float: right;
  background-color: #fff;
  height: auto;
}
.content .text-container h3 {
  padding: 10px;
  margin: 0;
  text-align: center;
  font-size: 22px;
}
.content .text-container p {
  padding: 15px;
  font-size: 18px;
  line-height: 1.6;
  text-align: left;
}
.content .img-container img {
  border: 3px solid #fff;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
}

/* 指示灯 */
div /deep/.el-carousel__indicators--horizontal {
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translate(-50%, 0);
  text-align: center;
}
div /deep/.el-carousel__indicator--horizontal button {
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-radius: 50%;
  opacity: 0.5;
}
div /deep/.el-carousel__indicator--horizontal.is-active button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  opacity: 1;
}

@media screen and (max-width: 1400px) {
  .xxnrbor {
    padding: 0 100px;
    height: 83vh;
  }

  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .nyTop {
    margin: 60px 0 30px;
  }
  .xnyNum {
    margin: 20px 60px;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .container-fluid {
    margin: 15px auto;
  }
  .hspan {
    font-size: 22px;
  }
  .xnytitle {
    font-size: 25px;
  }
  .xnyContent {
    font-size: 19px;
    margin: 0;
  }
  .banner-info p {
    font-size: 28px;
  }
  .rzTop h1 span,
  .xtTop h1 span,
  .nyTop h1 span {
    font-size: 25px;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop p,
  .nyTop p {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 19px;
    font-weight: 500;
    line-height: 20px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 5px 10px;
  }
  .sjzxImg {
    margin: 5px 0;
  }
  .xtImg {
    margin: 5px 0;
    height: 25vw;
  }
  .xtp {
    padding: 0;
    font-size: 24px;
  }
  .hover-content h1 {
    font-size: 18px;
    margin: 10px 0;
  }
  .jtzlHeight {
    height: 50px;
  }

  div /deep/ .jtzlImg img {
    height: 20vw;
  }
  .rzTop {
    margin: 0;
  }
  .content .text-container img {
    width: 80vw;
    height: 25vw;
  }
  .xxd {
    margin: 0;
  }
  .row {
    padding: 0;
  }
  .content .text-container p {
    padding: 5px;
    font-size: 16px;
    line-height: 1.5;
  }
  .xclose {
    top: 5px;
    right: 5px;
    font-size: 21px;
    width: 30px;
    height: 30px;
  }

  .banner-info span {
    font-size: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 350px;
  }

  div /deep/ .el-carousel__container {
    height: 95vh;
  }
  div /deep/ .el-carousel__arrow {
    height: 40px;
    width: 40px;
    font-size: 25px;
    background-color: rgba(31, 45, 61, 0.5);
  }

  div /deep/ .el-carousel__arrow--right {
    right: 5px;
  }
  div /deep/ .el-carousel__arrow--left {
    left: 5px;
  }

  /* 指示灯 */
  div /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translate(-50%, 0);
    text-align: center;
  }
  div /deep/.el-carousel__indicator--horizontal button {
    width: 10px;
    height: 10px;
  }
  div /deep/.el-carousel__indicator--horizontal.is-active button {
    width: 18px;
    height: 18px;
  }
  .content .text-container {
    height: 83vh;
  }
  .modal-content {
    padding: 45px 0;
  }
  .xmodaltop {
    top: 18px;
    font-size: 26px;
  }
  .azTop {
    margin-bottom: 50px;
    margin-top: 20px;
  }
}

@media screen and (max-width: 768px) {
  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .xnyNum {
    margin: 20px 20px;
  }
  .hspan {
    font-size: 20px;
  }
  .xnytitle {
    font-size: 20px;
  }
  .xnyContent {
    font-size: 13px;
    margin: 0;
  }
  .banner-info p {
    font-size: 28px;
  }
  .rzTop h1 span,
  .xtTop h1 span,
  .nyTop h1 span {
    font-size: 20px;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop p,
  .nyTop p {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 5px;
  }
  .sjzxImg {
    margin: 5px 0;
  }
  .xtImg {
    margin: 5px 0;
    height: 25vw;
  }
  .xtp {
    padding: 0;
    font-size: 16px;
  }
  .hover-content h1 {
    font-size: 13px;
    margin: 10px 0;
  }
  .jtzlHeight {
    height: 50px;
  }

  div /deep/ .jtzlImg img {
    height: 20vw;
  }
  .rzTop {
    margin: 0;
  }
  .content .text-container img {
    width: 80vw;
    height: 25vw;
  }
  .xxd {
    margin: 0;
  }
  .row {
    padding: 0;
  }
  .content .text-container p {
    padding: 5px;
    font-size: 13px;
    line-height: 1.5;
  }
  .xclose {
    top: 5px;
    right: 5px;
    font-size: 22px;
    width: 30px;
    height: 30px;
  }

  .banner-info span {
    font-size: 27px;
  }
  .cbp-spmenu-push .banner {
    height: 200px;
  }

  div /deep/ .el-carousel__container {
    height: 95vh;
  }
  div /deep/ .el-carousel__arrow {
    height: 40px;
    width: 40px;
    font-size: 25px;
    background-color: rgba(31, 45, 61, 0.5);
  }

  div /deep/ .el-carousel__arrow--right {
    right: 5px;
  }
  div /deep/ .el-carousel__arrow--left {
    left: 5px;
  }

  /* 指示灯 */
  div /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translate(-50%, 0);
    text-align: center;
  }
  div /deep/.el-carousel__indicator--horizontal button {
    width: 10px;
    height: 10px;
  }
  div /deep/.el-carousel__indicator--horizontal.is-active button {
    width: 18px;
    height: 18px;
  }
  .content .text-container {
    height: 80vh;
  }
  .modal-content {
    padding: 37px 0;
  }
  .xmodaltop {
    top: 18px;
    font-size: 26px;
  }
  .azTop {
    margin-bottom: 50px;
    margin-top: 20px;
  }
}

@media screen and (min-width: 2000px) {
  .page-heading .heading-content h1 {
    font-size: 40px;
  }
  .xnyContent {
    margin: 30px;
    font-size: 29px;
    line-height: 1.5;
  }
  .banner-info span {
    font-size: 65px;
  }
  .rzTop h1 span {
    font-size: 40px;
  }
  .rzTop p,
  .nyTop p {
    font-size: 29px;
    line-height: 1.5;
  }
  .xtp {
    font-size: 38px;
  }
  .hover-content h1 {
    font-size: 26px;
    line-height: 1.5;
  }
  .hover-content h1 {
    height: 100px;
  }
  .nyTop h1 span {
    font-size: 40px;
  }
  .content .text-container h3 {
    font-size: 35px;
  }
  .content .text-container p {
    font-size: 25px;
  }
  .jtzlHeight {
    height: 100px;
  }
  .xtTop h1 span {
    font-size: 40px;
  }
}
</style>
